import React from "react";
import { motion, useReducedMotion } from "framer-motion";
type RevealProps = {
  children: React.ReactNode;
  as?: "div" | "li";
  delay?: number;
  className?: string;
};
const ease = [0.23, 1, 0.32, 1] as const;
export function Reveal({
  children,
  as = "div",
  delay = 0,
  className
}: RevealProps) {
  const reduceMotion = useReducedMotion();
  const Component = as === "li" ? motion.li : motion.div;
  return <Component className={className} initial={reduceMotion ? false : {
    opacity: 0,
    y: 16
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: "0px 0px -60px 0px"
  }} transition={{
    duration: 0.3,
    ease,
    delay: Math.min(delay, 0.24)
  }} data-id="element-188" data-mp="2jrhuqspk8z3f">
      {children}
    </Component>;
}